import { render, staticRenderFns } from "./ShPopDelButton.md?vue&type=template&id=33f7165e"
import script from "./ShPopDelButton.md?vue&type=script&lang=js"
export * from "./ShPopDelButton.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports